import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Card } from 'src/app/page/not-found/card.blueprint';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {
public authen: any;

  constructor(private _location: Location) { }

  ngOnInit(): void {
  }
    public card = new Card({
        buttons: ["Open Link"],
        icons: ["report_problem"],
        subtitle: "This page is under construction, Try Again Later.",
        title: "Error Case"
    });
    redirect() {
      window.open("https://dev.acccloud.me:30356/login");
    }
}
